import { format } from "date-fns";

export const LeaveApplicationsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },

  {
    field: "startDate",
    headerName: "Start Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formatDate = format(new Date(params.value), "MM/dd/yyy");
      return formatDate;
    },
  },
  {
    field: "endDate",
    headerName: "End Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formatDate = format(new Date(params.value), "MM/dd/yyy");
      return formatDate;
    },
  },
  {
    field: "resumptionDate",
    headerName: "Resumption Date",
    flex: 1.5,
    type: "date",
    renderCell: (params) => {
      const formatDate = format(new Date(params.value), "MM/dd/yyy");
      return formatDate;
    },
  },

  { field: "statusDescription", headerName: "Status", flex: 1 },

  { field: "gender", headerName: "Gender", flex: 1 },
  { field: "leaveType", headerName: "Leave Type", flex: 1.3 },
  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  { field: "phoneNumber", headerName: "Phone Number", flex: 1.5 },
  { field: "email", headerName: "Email", flex: 1.5 },
];
export const AllPoliciesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "leaveType", headerName: "Leave Type", flex: 1 },
  { field: "gender", headerName: "Gender", flex: 1 },
  { field: "acrues", headerName: "Accrues", flex: 1, type: " boolean" },

  {
    field: "accrualRate",
    headerName: "Accrual Rate",
    flex: 1,
  },
  {
    field: "accrualDate",
    headerName: "Accrual Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formatDate = format(new Date(params.value), "MM/dd/yyy");
      return formatDate;
    },
  },
  {
    field: "canCarryForward",
    headerName: "Carry Forward",
    flex: 1.5,
    type: " boolean",
  },
  {
    field: "maxDaysCarryForward",
    headerName: "Max Days Carry Forward",
    flex: 1,
  },
  {
    field: "maxOpenApplications",
    headerName: "Max Open Applications",
    flex: 1,
  },

  { field: "maxDays", headerName: "Max Days", flex: 1 },
];
export const LeaveApproversColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "firstName", headerName: "First Name", flex: 1.3 },
  { field: "lastName", headerName: "Last Name", flex: 1.3 },
  { field: "phoneNumber", headerName: "Phone No.", flex: 1.3 },
  { field: "email", headerName: "Email", flex: 1.3 },
  { field: "role", headerName: "Role", flex: 0.7 },
  { field: "roleGroup", headerName: "Role Group", flex: 1.3},
  { field: "branch", headerName: "Branch", flex: 1 },
  { field: "region", headerName: "Region", flex: 1 },
];
export const CompanyCalendarSetupsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "recurringTypeId", headerName: "Recurring Type ID", flex: 1 },
  { field: "recurringType", headerName: "Recurring Type", flex: 1 },
  { field: "holiday", headerName: "Holiday", flex: 1 },
  { field: "isActive", headerName: "Is Active", flex: 1 },
];
export const userFinanceDetailsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "bankBranch", headerName: "Bank Branch", flex: 1 },
  { field: "bank", headerName: "Bank", flex: 1 },
  { field: "accountNumber", headerName: "Account Number", flex: 2},
  { field: "mpesaNumber", headerName: "Mpesa Number", flex: 1 },
];

export const requisitionApproversColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "firstName", headerName: "First Name", flex: 1.3},
  { field: "lastName", headerName: "Last Name", flex: 1.3 },
  { field: "phoneNumber", headerName: "Phone No.", flex: 1.3 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "role", headerName: "Role", flex: 0.7 },
  { field: "roleGroup", headerName: "Role Group", flex: 1.3},
  { field: "branch", headerName: "Branch", flex: 1 },
  { field: "region", headerName: "Region", flex: 1 },
];

export const imprestApplicationsColumns = [
  { field: "id", headerName: "ID", flex: 0.3},
  { field: "disbursementType", headerName: "Disbursement Type", flex: 1.2},
  { field: "title", headerName: "Title", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
  {
    field: "caseRelated",
    headerName: "Case Related",
    flex: 1,
    type: "boolean",
    renderCell: (params) => {
      const values = params.value === 0 ? "No" : "Yes";
      const coloredColor = values === "No" ? "red" : "green";
      return <div style={{ color: coloredColor }}>{values}</div>;
    },
  },

  { field: "statusDescription", headerName: "Status ", flex: 1 },

  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  { field: "phoneNumber", headerName: "Phone Number", flex: 1 },
  { field: "email", headerName: "Email", flex: 2 },

  { field: "branch", headerName: "Branch", flex: 1 },
  { field: "region", headerName: "Region", flex: 1 },
];

export const staffClaimApplicationsColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "disbursementType", headerName: "Disbursement Type", flex: 1.7 },
  { field: "title", headerName: "Title", flex: 0.7 },
  { field: "description", headerName: "Description", flex: 1 },
  { field: "totalAmount", headerName: "Total Amt ", flex: 1 },

  {
    field: "caseRelated",
    headerName: "Case Related",
    flex: 1.3,
    type: "boolean",
    renderCell: (params) => {
      const values = params.value === 0 ? "No" : "Yes";
      const coloredColor = values === "No" ? "red" : "green";
      return <div style={{ color: coloredColor }}>{values}</div>;
    },
  },

  { field: "statusDescription", headerName: "Status ", flex: 0.7 },

  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  { field: "phoneNumber", headerName: "Phone No", flex: 1 },
  { field: "email", headerName: "Email", flex: 0.7 },
  { field: "branch", headerName: "Branch", flex: 0.7},
  { field: "region", headerName: "Region", flex: 0.7 },
];
export const AllImprestSurrenderColumns = [
  { field: "id", headerName: "ID", flex: 0.2, required: true },
  { field: "totalAmount", headerName: "Total Amt", flex: 1, required: true },

  {
    field: "disbursementType",
    headerName: "Disbursement Type",
    flex: 1.5,
    required: true,
  },
  { field: "title", headerName: "Title", flex: 0.5, required: true },
  { field: "description", headerName: "Description", flex: 1.1, required: true },
  { field: "actualSpent", headerName: "Actual Spent", flex: 1.2, required: true },
  {
    field: "remainingAmount",
    headerName: "Remaining Amt",
    flex: 1.2,
    required: true,
  },
  {
    field: "statusDescription",
    headerName: "Status ",
    flex: 0.7,
    required: true,
  },

  { field: "firstName", headerName: "First Name", flex: 1.1, required: true },
  { field: "lastName", headerName: "Last Name", flex: 1.1, required: true },
  { field: "phoneNumber", headerName: "Phone No.", flex: 1.1, required: true },

  { field: "role", headerName: "Role", flex: 0.5, required: true },

  { field: "branch", headerName: "Branch", flex: 0.6, required: true },
  { field: "region", headerName: "Region", flex: 0.6, required: true },
];
export const imprestSurrenderLinesColumns = [
  { field: "id", headerName: "ID", flex: 0.3, required: true },
  { field: "amount", headerName: " Amount", flex: 1, required: true },
  { field: "description", headerName: "Description", flex: 2, required: true },
];
export const staffClaimLinesColumns = [
  { field: "id", headerName: "ID", flex: 0.3, required: true },
  { field: "amount", headerName: " Amount", flex: 1, required: true },
  { field: "description", headerName: "Description", flex: 2, required: true },
];
export const allRelievers = [
  { field: "id", headerName: "ID", flex: 0.3, required: true },

  {
    field: "leaveType",
    headerName: "Leave Type",
    flex: 1,
    required: true,
  },

  {
    field: "statusDescription",
    headerName: "Status ",
    flex: 1,
    required: true,
  },

  {
    field: "applicantFirstName",
    headerName: "Applicant First Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "applicantLastName",
    headerName: "Applicant Last Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "relieverFirstName",
    headerName: "Reliever First Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "relieverLastName",
    headerName: "Reliever Last Name",
    flex: 1.5,
    required: true,
  },

  { field: "role", headerName: "Role", flex: 1, required: true },

  { field: "branch", headerName: "Branch", flex: 1, required: true },
  { field: "region", headerName: "Region", flex: 1, required: true },
];
